var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.3134 3.33333H16.6135L11.5884 9.33419L17.5 17.5H12.8713L9.24593 12.5475L5.09769 17.5H2.7962L8.17098 11.0814L2.5 3.33333H7.24621L10.5232 7.86013L14.3134 3.33333ZM13.5061 16.0615H14.7806L6.55368 4.69624H5.186L13.5061 16.0615Z",
  fill: "white"
}))));
export default SvgX;